import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Team from "@/pages/Team";
import Consultation from "@/pages/Consultation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/team" element={<Team />} />
              <Route path="/book-consultation" element={<Consultation />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
